import React from "react";

import { Container } from "@mui/material";
import { Helmet } from "react-helmet";

import DynamicComponentLoader from "../components/DynamicComponent";

export default function Team({ handleBookATourClick, theme, ...props }) {
  const { Content } = props?.data;

  return (
    <>
      <Helmet>
        <title itemProp="name" lang="en">
          The Kahanoff Centre – Our Team
        </title>
      </Helmet>
      <Container disableGutters align="center" maxWidth={"false"}>
        {Content?.map((block, index) => {
          return <DynamicComponentLoader key={`team-${index}`} theme={theme} {...block} />;
        })}
      </Container>
    </>
  );
}
